var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.componentClass, style: _vm.componentStyle },
    [
      _c("wa-sample-spinner", { attrs: { size: `${_vm.iconSize}` } }),
      _vm._v(" "),
      _c("p", { staticClass: "margin-top-xl margin-bottom-0" }, [
        _vm._v(_vm._s(_vm.content)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }